import "./acl";
import "./apexchart";
import "./axios";
import "./bootstrap";
import "./clipboard";
import "./composition-api";
import "./portal-vue";
import "./sweet-alerts";
import "./toastification";
// import "./tour";
import "./vue-clipboard";
import "./vue-element-loading";
import "./vue-moment";
import "./vue-numeric";
import "./vue-select";
import "./vue-tippy";

require("@core/assets/fonts/feather/iconfont.css");
